import { isEmpty, lte, gt, lt, size, min, trimEnd } from 'lodash';

import { IPdfTools } from '../pdf.type';

const truncateText = (
  text: string,
  pdfTools: Pick<IPdfTools, 'preference' | 'utils'>,
  maxWidth?: number,
  linePrefix?: string,
  ellipsis: string = '...',
  // eslint-disable-next-line max-params
): string => {
  if (isEmpty(text)) {
    return text;
  }

  const widthOfString = pdfTools.utils.widthOfString;

  const textWidth = widthOfString(`${linePrefix ?? ''}${text}`);

  // #TODO need remove margin
  const textMaxWidth = maxWidth ?? pdfTools.preference.width;

  if (lte(textWidth, textMaxWidth)) {
    return text;
  }

  const textLength = size(text);
  const textTotalLength = textLength - size(ellipsis);

  const ellipsisWidth = widthOfString(ellipsis);
  const textMaxWidthWithEllipsis = textMaxWidth - ellipsisWidth;

  let maxCharPos = textTotalLength;

  let subsText = text;
  let subsTextWidth = textWidth;

  const calcSubsText = (maxPos: number): void => {
    subsText = text.substr(0, maxPos);

    // calc whole line text
    subsTextWidth = widthOfString(`${linePrefix ?? ''}${subsText}`);
  };

  /**
   * use to store last two char pos
   */
  let lastTwoCharPos = [maxCharPos];

  const setLastTwoCharPos = (charPos): void => {
    if (size(lastTwoCharPos) === 2) {
      lastTwoCharPos = [charPos, lastTwoCharPos[0]];
    } else {
      lastTwoCharPos.unshift(charPos);
    }
  };

  let isContinue = true;

  while (isContinue) {
    calcSubsText(maxCharPos);

    const isGreaterThanMax = gt(subsTextWidth, textMaxWidthWithEllipsis);
    const isLessThanMax =
      lt(subsTextWidth, textMaxWidthWithEllipsis) &&
      maxCharPos < textTotalLength;

    isContinue = isGreaterThanMax || isLessThanMax;

    if (isGreaterThanMax) {
      maxCharPos -= 1;
    }

    if (isLessThanMax) {
      maxCharPos += 1;
    }

    // if char pos is going to loop, just return min char pos subs text
    if (size(lastTwoCharPos) === 2 && maxCharPos === lastTwoCharPos[1]) {
      // use lower index & break
      maxCharPos = min(lastTwoCharPos);
      calcSubsText(maxCharPos);
      break;
    }

    setLastTwoCharPos(maxCharPos);
  }

  return `${trimEnd(subsText)}${ellipsis}`;
};

export { truncateText };
